import {
    Dialog,
    DialogTitle,
    Stack,
    IconButton,
    Typography,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Divider,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import defaultAxios, { AxiosError } from "axios";
import Swal from "sweetalert2";
import { SelectedProductBundling } from "../../constants/types";
import useDeleteMultipleItems from "../../services/mutations/useDeleteMultipleItems";

interface IModalDeleteMultipleStokProps {
    refetch: () => void;
    handleCollapseClose: () => void;
    open: boolean;
    onClose: () => void;
    selectedProducts: SelectedProductBundling[];
}

const ModalDeleteMultipleStok = ({
    refetch,
    handleCollapseClose,
    open,
    onClose,
    selectedProducts,
}: IModalDeleteMultipleStokProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const deleteMultipleItems = useDeleteMultipleItems();

    const handleDelete = () => {
        if (selectedProducts.length === 0) {
            onClose();
            return;
        }
        deleteMultipleItems.mutate(
            { itemId: selectedProducts.map((product) => product.id) },
            {
                onSuccess: () => {
                    Swal.fire({
                        title: "Item berhasil dihapus!",
                        position: "top-end",
                        showConfirmButton: false,
                        icon: "success",
                        toast: true,
                        timer: 3000,
                        timerProgressBar: true,
                        showCloseButton: true,
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    refetch();
                    onClose();
                    handleCollapseClose();
                },
                onError: (error) => {
                    handleErrorResponse(error);
                },
            },
        );
    };

    const handleErrorResponse = useCallback(
        (error) => {
            if (defaultAxios.isAxiosError(error)) {
                const serverError = error as AxiosError<any>;
                if (serverError && serverError.response) {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `${serverError.response.data.message}`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    onClose();
                } else {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `Telah Terjadi Kesalahan`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    onClose();
                }
            }
        },
        [onClose],
    );

    return (
        <Dialog
            maxWidth="xs"
            fullWidth={true}
            fullScreen={isPhoneScreen}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: 1,
                },
            }}
        >
            <DialogTitle>
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                >
                    <Typography variant="h6" fontWeight="bold">
                        Hapus Barang
                    </Typography>

                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>

            <Divider />

            <DialogContent>
                <DialogContentText>
                    Apakah Anda yakin ingin menghapus barang yang dipilih secara
                    permanen?
                    {selectedProducts.length > 0 && (
                        <ul>
                            {selectedProducts.map((product) => (
                                <li key={product.id}>{product.nama}</li>
                            ))}
                        </ul>
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                
                <Button
                    variant="outlined"
                    onClick={onClose} 
                    color="error"
                >
                    Tidak
                </Button>

                <Button 
                    variant="contained"
                    onClick={handleDelete} 
                    color="error"
                >
                    Hapus
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDeleteMultipleStok;
